import React from "react";
import ExpandingComponent from "./ExpandingComponent";
import TransitionChevron from "./TransitionChevron";
import { Span } from "../Typography"
import classNames from "classnames";
import styles from "./ExpandingComponent.module.scss";
import Popover from "../Popover";
import { Card } from "../Cards"
import cardStyles from "../Cards/Card.module.scss";

export const ExpandingComponentsGroup = React.memo(({children}) => {
    return <div className={cardStyles['card-group']}>
        {children}
    </div>
})

export const ExpandingRadioOptionComponent = React.memo(({ title, selectedOption, Popover: PopoverContent, children, disabled, disabledReason }) => {
    return <Card hasHoverEffect={true}>
        <ExpandingComponent
            Component="div"
            contentClassName={styles["radio-component-content"]}
            headerClassName={classNames(styles['radio-component-header'], { [styles['disabled']]: disabled })}
            disabled={disabled}
            ButtonChildren={({ isOpen }) =>
                <>
                    <div>
                        {PopoverContent && <Popover placement="center" triggerOnClick white triggerClassName={styles['popover-trigger']}><PopoverContent/></Popover>}
                        <Span bold className={classNames(styles.title, { [styles['active']]: isOpen })} color={disabled ? "disabled-grey" : undefined}>{title}</Span>
                    </div>
                    <div>{!isOpen && <Span className={styles.option} color={disabled ? "disabled-grey" : undefined}>{selectedOption}</Span>}</div>
                    {!disabledReason && <TransitionChevron isActive={isOpen} color={disabled ? "disabled" : "text"} thin wide className={styles.chevron}/>}
                    {disabledReason && <Popover placement="center" white Trigger={() => {
                        return <TransitionChevron isActive={isOpen} color="disabled" thin wide className={styles.chevron}/>
                    }}>
                        {disabledReason}
                    </Popover>}
                </>
            }>
            {children}
        </ExpandingComponent>
    </Card>
})

export const ExpandingNoOptionsComponent = React.memo(({title, selectedOption, disabled, Popover: PopoverContent, popoverContentStyle}) => {
    return <Card>
        <div className={classNames(styles['radio-component-header'], styles['disabled'])}>
            <div>
                {PopoverContent && <Popover placement="center" triggerOnClick white contentStyle={popoverContentStyle} triggerClassName={styles['popover-trigger']}><PopoverContent/></Popover>}
                <Span bold className={classNames(styles.title)} color={disabled ? "disabled-grey" : undefined}>{title}</Span>
            </div>
            <div><Span className={styles.option} color={disabled ? "disabled-grey" : undefined}>{selectedOption}</Span></div>
            <div/>
        </div>
    </Card>
})